<mat-dialog-content class="mat-dialog-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Regimen FollowUpSop History</h4><i class="fas fa-times pull-right fontL3" (click)="hideModal()"></i>
  </div>
  <div class="modal-body">
    <div class="col-xs-12" *ngIf="loading">Loading...</div>
    <div class="col-xs-12" style="height:500px; overflow-y:scroll" #historyList (scroll)="onScrollList()">
      <div class="col-xs-12" *ngFor="let regimenHistory of regimenHistory">
        <div class="bdr-2-black bdr-rad-10 p-4">
          <collapse title="{{regimenHistory.byUser?.username}} {{regimenHistory.createdAt | amDateFormat: 'MMM DD YYYY,hh:mm a'}} total-Scenarios {{regimenHistory.followUpSop.length}}" [iconClass]="this.appConfig.Shared.ListSideBar.Icons.REGIMEN_SOP">
            <div *ngFor="let node of regimenHistory.followUpSop;let i = index;">
              <followup-sop class="col-xs-12" [node]="node" prefix="{{i}}" [regimenId]="regimen.get('regimenId')"></followup-sop>
            </div>
          </collapse>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
